import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 13894 18027"
    {...props}
  >
    <path
      d="M11876 2820H3651v4431h7574c558 0 974 126 1247 374 277 247 411 579 411 986s-134 743-403 999c-273 256-688 386-1255 386H3651v5136h8506c575 0 1007 134 1297 398 293 265 440 622 440 1062 0 424-147 772-440 1037-290 264-722 398-1297 398H2237c-793 0-1364-176-1712-528-349-353-525-924-525-1708V2237c0-525 80-953 235-1284 155-332 399-575 730-726C1297 76 1721 0 2237 0h9639c583 0 1015 130 1296 386 282 260 424 600 424 1015 0 428-142 773-424 1033-281 256-713 386-1296 386z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
